import { type ReactNode } from 'react';

interface ShareDeviceDialogBaseProps {
  children: ReactNode;
  onClose?: () => void;
  showCloseButton?: boolean;
}

/**
 * ShareDeviceダイアログの共通ベースコンポーネント
 * ダイアログ内のレイアウト構造を統一
 */
export const ShareDeviceDialogBase = ({
  children,
  onClose,
  showCloseButton = false,
}: ShareDeviceDialogBaseProps) => {
  return (
    <div className="dialog__line">
      <div className="dialog__area">
        {showCloseButton && onClose && (
          <button
            className="dialog__btn--close"
            type="button"
            onClick={onClose}
          >
            ×
          </button>
        )}
        {children}
      </div>
    </div>
  );
};
